import { createFileRoute, redirect } from "@tanstack/react-router";

import { LoginForm } from "@/components/auth/login-form";
import { resolveAuthRedirectTarget } from "@/lib/auth-redirect";
import { noIndexSeo } from "@/lib/seo";

import { redirectSchema } from "./-shared/redirect-schema";

export const Route = createFileRoute("/(landing)/(auth)/sign-in")({
	validateSearch: redirectSchema,
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "Sign In | StudyOS",
			description: "Sign in to your StudyOS account to continue your study sessions.",
			pathname: match.pathname,
		}),
	beforeLoad: async ({ search, context }) => {
		const _redirectTo = search?.redirect;

		if (context.user && search?.from) {
			throw redirect({ to: search.from, replace: true });
		}

		if (_redirectTo) {
			const redirectTo = resolveAuthRedirectTarget(_redirectTo);

			throw redirect({ to: redirectTo });
		}
	},
});

function RouteComponent() {
	const search = Route.useSearch();

	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				<LoginForm redirectTo={resolveAuthRedirectTarget(search?.from)} />
			</div>
		</div>
	);
}
